import { useState } from 'react';

export const usePagination = ({ initialPage = 1, initialPerPage = 15 }) => {
  const [pagination, setPagination] = useState({
    currentPage: initialPage,
    lastPage: 1,
    total: 0,
    perPage: initialPerPage
  });

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.lastPage) {
      setPagination(prev => ({
        ...prev,
        currentPage: newPage
      }));
    }
  };

  const updatePaginationData = (metaData) => {
    setPagination(prev => ({
      ...prev,
      currentPage: metaData.current_page,
      lastPage: metaData.last_page,
      total: metaData.total,
      perPage: metaData.per_page
    }));
  };

  const getPageNumbers = () => {
    const currentPage = pagination.currentPage;
    const totalPages = pagination.lastPage;
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const getItemRange = () => {
    const start = ((pagination.currentPage - 1) * pagination.perPage) + 1;
    const end = Math.min(pagination.currentPage * pagination.perPage, pagination.total);
    return { start, end };
  };

  return {
    pagination,
    handlePageChange,
    updatePaginationData,
    getPageNumbers,
    getItemRange
  };
};
